import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/home.css";
import background from "../assets/images/background.jpeg";
import { Lightbulb, Users, Target } from "lucide-react";
import LogoCarousel from "../LogoCarousel";

const Home = () => {
  return (
    <div className="home-section">
      {/* Hero Background */}
      <div
        className="hero-background"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="home-overlay"></div>
      </div>

      {/* Content Wrapper */}
      <div className="home-content-wrapper">
        <div className="home-hero-content">
          {/* Hero Section */}
          <div className="home-hero-text">
            <h2 className="home-hero-title">Transform Your Digital Presence</h2>
            <p className="home-hero-description">
              Delivering innovative software solutions that drive business growth.
            </p>
          </div>

          {/* Call-to-Actions */}
          <div className="home-cta-section">
            <a href="/services" className="home-primary-cta">
              Explore Services
              <span className="home-cta-arrow">→</span>
            </a>
            {/* <a href="/contact" className="home-secondary-cta">
              Get in Touch
            </a> */}
          </div>

          {/* Feature Grid */}
          <div className="home-feature-grid">
            {[
              {
                icon: Lightbulb,
                title: "Our Mission",
                description:
                  "At the heart of our business lies a simple truth: Your success is our success. We believe that innovative software solutions should be accessible to businesses of all sizes, not just industry giants. By providing affordable, high-quality software development services, we empower organizations to thrive in the digital age.",
              },
              {
                icon: Users,
                title: "Our Community",
                description:
                  "In the ever-evolving landscape of technology, we believe that true innovation flourishes when knowledge is shared. Our commitment extends beyond writing code – we're building a community where learning never stops and everyone has a chance to grow.",
                quote:
                  "When one of us grows, we all rise. This is the power of community-driven development.",
              },
              {
                icon: Target,
                title: "Our Commitment",
                description:
                  "At our core, we believe that integrity isn't just a word—it's the foundation of everything we build. Every line of code we write, every solution we design, and every interaction we have is guided by an unwavering commitment to doing what's right.",
                quote:
                  "Excellence is not a skill—it's an attitude. We don't just meet standards; we set them.",
              },
            ].map(({ icon: Icon, title, description, quote }, index) => (
              <div key={index} className="home-feature-item">
                <div className="home-feature-icon">
                  <Icon className="home-icon" />
                </div>
                <h3>{title}</h3>
                <p>{description}</p>
                {quote && (
                  <div className="home-quote-container">
                    <div className="home-quote-line"></div>
                    <p className="home-quote">{quote}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Logo Carousel */}
      <LogoCarousel />
    </div>
  );
};

export default Home;